import React, { Component } from 'react'

import Footer from './Footer'
import Logo from './Logo'

export default class Content extends Component {
  render() {
    return (
      <div className="container-fluid vertical content scrollable">
        <div className="row no-margin detail">

          <div className="col-md-4 col-sm-12">
            <div className="app-sidebar">
              <Logo />
              {this.props.sidebarChildren || null}
            </div>
          </div>

          <div className="col-md-8 col-sm-12">
            {this.props.children}
          </div>
        </div>

        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/Content.js